<template>
    <v-card
      class="mx-auto text-center"
      color="#394264"
      dark
      max-width="800"
      style="margin-top: 5px;"
      media="(max-width: 768px)"
    >
      <v-card-text>
        <v-sheet color="#3468AF">
            <template>
                <canvas ref="chartCanvas" width="580" height="200"></canvas>
            </template>
        </v-sheet>
      </v-card-text>

      <v-card-text>
        <div class="text-h4 font-weight-thin">
          TOTAL DÍZIMO MÊS EM R$
        </div>
      </v-card-text>
    </v-card>
</template>

<script>
import api from '../../../../plugins/api'
import Cookie from 'js-cookie'
import VueJwtDecode from 'vue-jwt-decode'
export default {
  data: () => ({
    dataYarray: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  }),
  mounted () {
    this.chartDizimoMonths()
  },
  methods: {
    drawChart () {
      const canvas = this.$refs.chartCanvas
      const ctx = canvas.getContext('2d')

      // Informações dos dados em Y e X
      // const dataY = [10, 20, 35, 15, 30, 25]
      // const dataX = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun']
      // const dataY = [
      //   0,
      //   966.69,
      //   1000.50,
      //   0,
      //   312.79,
      //   14772.42,
      //   750.00,
      //   515.00,
      //   0,
      //   0,
      //   0,
      //   0
      // ]
      const dataY = this.dataYarray

      const dataX = [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez'
      ]

      // Configurações do gráfico
      const chartHeight = 100
      const chartWidth = 520
      const chartMargin = 25
      const chartOriginX = 25
      const chartOriginY = canvas.height - chartMargin
      const dataPointRadius = 4

      // Desenhar eixo Y
      ctx.beginPath()
      ctx.moveTo(chartOriginX, chartOriginY)
      ctx.lineTo(chartOriginX, chartMargin)
      ctx.stroke()

      // Desenhar eixo X
      ctx.beginPath()
      ctx.moveTo(chartOriginX, chartOriginY)
      ctx.lineTo(canvas.width - chartMargin, chartOriginY)
      ctx.stroke()

      // Desenhar pontos de dados
      ctx.fillStyle = 'rgba(255, 255, 255, .7)'
      for (let i = 0; i < dataX.length; i++) {
        const x = chartOriginX + (i * (chartWidth / (dataX.length - 1)))
        const y = chartOriginY - (dataY[i] * (chartHeight / Math.max(...dataY)))

        ctx.beginPath()
        ctx.arc(x, y, dataPointRadius, 0, 2 * Math.PI)
        ctx.fill()

        // Escrever os valores de Y ao lado dos pontos
        ctx.save()
        // ctx.translate(0, 0)
        // ctx.rotate(100 / 4)
        // ctx.fillStyle = this.cor[i]
        ctx.fillText(dataY[i], x + 1, y - 5)
        ctx.restore()

        // Escrever os valores de X abaixo dos pontos
        ctx.save()
        ctx.translate(x, chartOriginY + 20)
        ctx.rotate(-Math.PI / 4)
        ctx.fillText(dataX[i], 0, 1)
        ctx.restore()
      }
    },
    chartDizimoMonths () {
      const getToken = Cookie.get('token')
      const decriptToken = VueJwtDecode.decode(getToken)
      api.get('reports/chart-dizimo-months?idchurch=' + Number(decriptToken.id_church)).then((resp) => {
        // console.log('Reports Chart: ', resp.data)
        resp.data.objeto.forEach(element => {
          this.dataYarray[element.mes - 1] = element.total
        })
        // console.log('new DataY: ', this.dataYarray)
        this.drawChart()
      }).catch()
    }
  }
}
</script>

<style scoped>

</style>
